var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.techinput_level},_vm._l((_vm.level),function(i){return _c('span',{key:i,class:_vm.$style.techinput_level__dot})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }